var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.applicationMaintenance)?_c('Maintenance'):_c('ComponentResolverMobile',{attrs:{"component-id":"AppWorkspace","override-component-id":_vm.overrideComponentId}})
}
var staticRenderFns = []

export { render, staticRenderFns }